import type CycleHistoryData from '../../../models/CycleHistoryDataModel';
import type IsoDate from '../../../models/IsoDate';
import { requestAndParse, requestSuccessful } from '../request';

const getStudentCycleHistory = async (
    studentId: number,
    cycleStart: IsoDate,
) => {
    const route = 'charts/get-student-cycle-history';
    const payload = { studentId, cycleStart };

    const response = await requestAndParse(route, payload, 'GET');

    const cycleHistoryData = (response.body ?? {}) as CycleHistoryData;

    return {
        cycleHistoryData,
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default getStudentCycleHistory;
